/****************************************************************************************
 * File Name    : SheetPatrol.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="9">
                <div class="gutter-box">
                    <PageHeader title = "점검일지 작성 현황" />
                </div>
            </a-col>
            <a-col class="gutter-row" :span="15">
                <div class="gutter-box div_action">
                    <select v-model="sheetCategory" class="native-select" style="margin-right: 10px; width: 100px">
                        <option value="">구분</option>
                        <option value="생산라인">생산라인</option>
                        <option value="필터">필터</option>
                        <option value="자재/출하">자재/출하</option>
                        <option value="공무">공무</option>
                        <option value="실험실">실험실</option>
                        <option value="공사관리">공사관리</option>
                        <option value="기타">기타</option>
                    </select>
                    <select 
                        v-model="pop" 
                        class="native-select"
                        style="margin-right: 10px; width: 200px">
                        <option value="" disabled selected>제목</option>
                        <option v-for="option in titleOptions" :key="option.name" :value="option.name">
                            {{ option.title }}
                        </option>
                    </select>	
                    <span class = 'icon_button' @click="handlerToCreateCSForSafetyPop()">	
                        <a-tag color="#2980B9" style="cursor:pointer;">	
                            <a-icon type="plus-circle" /> 불러오기	
                        </a-tag>	
                    </span>
                </div>
            </a-col>
        </a-row>
        <a-divider type = 'horizontal' />
        <a-space align="end">
            <!-- <a-statistic title="작성필요" :value="data.length" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="check-circle" />
                </template>
            </a-statistic> -->
            <a-statistic title="작성중" :value="pagination1.total" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="question-circle" />
                </template>
            </a-statistic>
             <a-statistic title="작성완료" :value="pagination2.total" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="exclamation-circle" />
                </template>
            </a-statistic>
            <a-radio-group style = ''>
                <!-- <a-radio-button value="작성필요">작성필요 보기</a-radio-button> -->
                <!-- <a-radio-button value="작성중">작성중 보기</a-radio-button> -->
                <!-- <a-radio-button value="작성완료">작성완료 보기</a-radio-button> -->
                <a-radio-button value="모두">모두보기</a-radio-button>
            </a-radio-group>
        </a-space>
        <p/>
        <a-progress type = 'line' :percent="90" strokeColor = '#C7C6C6'/>
        <a-card>
            <a-table :columns="columns" size = "small" :bordered=false :data-source="data" :pagination="pagination1" :scroll="{ x: 0, y: '30vh' }" @change="handleTable1Change">
                <span slot="tags" slot-scope="tags">
                    <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                        {{ tag.toUpperCase() }}
                    </a-tag>
                </span>
                <span slot="name" slot-scope="text">{{ text }}</span>
                <span slot="pop" slot-scope="pop">{{ pop }}</span>
                <span slot="checkState" slot-scope="checkState">{{ checkState }}</span>
                <span slot="updated" slot-scope="updated">{{ updated }}</span>
                <span slot="action" slot-scope="record">
                    <!-- <span style = 'cursor:pointer' @click="handlerToConfirmProductCS(record.key, 'C')"><a-icon type="check-circle" /> Confirm</span>	
                    <a-divider type="vertical" /> -->	
                    <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'U')"><a-icon type="edit" /> Edit</span>	
                    <a-divider type="vertical" />	
                    <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'U')"><a-icon type="delete" /> Delete</span>
                </span>
            </a-table>
        </a-card>
        <p/>
        <a-form class="" layout = "vertical" >
            <!-- <a-card>
                <a-form-item label="점검시트 작성 일자설정">
                    <a-space align="end">
                        <a-date-picker />
                        <a-radio-group style = ''>
                            <a-radio-button value="작성필요">작성필요 보기</a-radio-button>
                            <a-radio-button value="작성중">작성중 보기</a-radio-button>
                            <a-radio-button value="작성완료">작성완료 보기</a-radio-button>
                            <a-radio-button value="모두">모두보기</a-radio-button>
                        </a-radio-group>
                    </a-space>
                </a-form-item>
                <p/>
                <a-table :columns="columns2" size = "small" :bordered=false :data-source="data" :pagination="false" :scroll="{ x: 0, y: '57vh' }">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" >
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="">
                        <a-checkbox @change="onChange">
                            선택
                        </a-checkbox>
                    </span>
                </a-table>
            </a-card>
            <p/> -->
            <a-card>
                <a-space align="end">
                    일지 조회
                    <div class="filter-input-container">
                        <div class="custom-input-group">
                            <a-input v-model="filterCS" style="max-width: 300px;" />
                            <select class="native-select filter-select" v-model="filterField">	
                                <option value="관리구분">관리구분</option>
                                <option value="제목">제목</option>	
                                <option value="대상">대상</option>
                                <option value="결과">결과</option>	
                            </select>
                        </div>
                    </div>

                    일자 조회
                    <date-picker v-model="filterDateStartCS" valueType="format" format="YYYY-MM-DD" style="width:120px;"></date-picker> ~
                    <date-picker v-model="filterDateEndCS" valueType="format" format="YYYY-MM-DD" style="width:120px;"></date-picker>
                    
                    <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetFilters">초기화</a-button>
                </a-space>
                <p/>
                <!-- <div v-if="isFiltered" style="margin-bottom: 10px; color: #1890ff;">
                    <a-icon type="filter" /> 검색 조건: 
                    <span v-if="filterCS">{{ filterField }}: "{{ filterCS }}"</span>
                    <span v-if="filterCS && (filterDateStartCS || filterDateEndCS)"> | </span>
                    <span v-if="filterDateStartCS || filterDateEndCS">
                        기간: {{ filterDateStartCS || '전체' }} ~ {{ filterDateEndCS || '현재' }}
                    </span>
                    <span style="margin-left: 5px;">(검색결과: {{ pagination2.total }}건)</span>
                </div> -->
                <a-table :columns="columns3" size = "small" :bordered=false :data-source="data3" :pagination="pagination2" :scroll="{ x: 0, y: '57vh' }" @change="handleTable2Change">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="checkState" slot-scope="checkState">{{ checkState }}</span>
                    <span slot="updated" slot-scope="updated">{{ updated }}</span>
                    <span slot="action" slot-scope="record">
                        <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'V')"><a-icon type="edit" /> Edit</span>	
                        <a-divider type="vertical" />	
                        <!-- <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'D')"><a-icon type="delete" /> Delete</span> -->
                    </span>
                </a-table>
            </a-card>

        </a-form>
        <a-drawer title="" placement="right" :closable="false" :visible="flagForDrawer" @close="handlerForCloseDrawer" width="100%" >
            <SafetyViewer :target = "target" :pop = "pop" :showSaveBtn = true :showConfirmBtn = true v-on:flagForDrawer="handlerForCloseDrawer" v-on:editSafetyCS="handlerToEditSafetyCS" />
        </a-drawer>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";
import SafetyViewer from "./SafetyViewer.vue" ;

const userAgent = navigator.userAgent.toLowerCase();
const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|samsungbrowser|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

let columns = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 150},
    {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 300},
    {    title: '대상' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 150},
    {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'checkState'  }, width : 80},
    {    title: '등록일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 120},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 150},
];
if (isTablet) {
    columns = [
        {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        }, width : 80},
        {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 100},
        {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 200},
        {    title: '대상' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 100},
        {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'checkState'  }, width : 80},
        {    title: '등록일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width: 120},
        {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      }, width: 150},
    ];
}

const columns2 = [
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 100},	
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},	
    {    title: '이름'    ,   dataIndex: 'name' ,   key: 'name'     ,  scopedSlots: { customRender: 'name'        },},
];
let columns3 = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 150},
    {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 300},
    {    title: '대상' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 150},
    {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'checkState'  }, width : 80},
    {    title: '등록일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 120},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 150},
];
if (isTablet) {
    columns3 = [
        {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        }, width : 80},
        {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 100},
        {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 200},
        {    title: '대상' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 100},
        {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'checkState'  }, width : 80},
        {    title: '등록일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width: 120},
        {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      }, width: 150},
    ];
}

const data = [
  {    key: '1',    name: 'FGCS210505-WP400-V1 보류중 20200401-15:30'   ,  tags: ['필요'],  },
  {    key: '2',    name: 'FGCS210505-WP301-V1 보류중 20200329-09:30'   ,  tags: ['필요'],  },
  {    key: '3',    name: 'PCCS210505-WP400-V1 완료 20200401-15:30'     ,  tags: ['진행'],  },
  {    key: '4',    name: 'PCCS210505-WP301-V1 완료 20200329-09:30'     ,  tags: ['완료'],  },
];
const data3 = [
  {    key: '1',    name: '정수기', model: 'WP-400',cs : 'FGCS210505-WP400-V1 ',id: '홍길동',created:'2021-01-01',updated:'2021-01-01' ,  tags: ['완료'],  },
  {    key: '2',    name: '정수기', model: 'WP-400',cs : 'FGCS210505-WP400-V1 ',id: '홍길동',created:'2021-01-01',updated:'2021-01-01' ,  tags: ['완료'],  },

];
export default {
    name: 'SheetSafety',
    components: {
        PageHeader ,
        DatePicker, 
        SafetyViewer,
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            data,
            columns,
            columns2,
            columns3,
            data3,
            data3Backup: [],
            dataArray: [],	
            dataArray3: [],	
            pop: null,	
            target: null,	
            filterCS : '',	
            filterField: '관리구분',
            filterDateStartCS: '',
            filterDateEndCS: '',
            titleOptions: [],
            allTitleOptions: [], // 원본 데이터 저장
            titleOptionsLoading: false,
            pagination1: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            pagination2: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            sheetCategory: '',
            isFiltered: false, // 필터링 상태 저장
        };
    },
    mounted() {
        this.pop = sessionStorage.getItem('safety_pop') || '';
        // this.sheetCategory = sessionStorage.getItem('safety_category') || '';
        
        this.isDataLoaded = true;
        this.fetchProductCSList();
        this.fetchTitleOptions();

        if (isTablet) {
            let x;
            let els1 = document.body.querySelectorAll('.ant-layout-header');
            for (x = 0; x < els1.length; x++) {
                els1[x].style.display = 'none';
            }
            let els2 = document.body.querySelectorAll('.ant-breadcrumb');
            for (x = 0; x < els2.length; x++) {
                els2[x].style.display = 'none';
            }
            let els3 = document.body.querySelectorAll('.ant-divider-horizontal');
            for (x = 0; x < els3.length; x++) {
                els3[x].style.display = 'none';
            }
            let els4 = document.body.querySelectorAll('.desktop-only');
            for (x = 0; x < els4.length; x++) {
                els4[x].style.display = 'none';
            }
            let els5 = document.body.querySelectorAll('.ant-layout-sider');
            for (x = 0; x < els5.length; x++) {
                els5[x].style.display = 'none';
            }
        }
    },
    watch: {
        sheetCategory() {
            this.filterTitleOptions();
        }
    },
    methods : {
        // showDrawer() {
        //     this.flagForDrawer = true;
        // },
        // closeDrawer() {
        //     this.flagForDrawer = false;
        // },
        // editTool() {
        //     console.log("## editTool in Tools ##");
        //     this.flagForDrawer = true;
        // },
        // deleteTool() {
        //     console.log("## deleteTool in Tools  ##");
        //     this.flagForDrawer = true;
        // }
        fetchProductCSList(skipBarcodeScan, forceView) {
            this.dataArray = [];
            this.data = [];
            this.data3 = [];
            
            // 두 개의 API 호출을 병렬로 처리
            this.fetchStateOData(skipBarcodeScan, forceView);
            this.fetchStatePData();
        },
        
        fetchStateOData(skipBarcodeScan, forceView, page = 1, pageSize = 10) {
            // 작성중(state=O) 데이터 조회
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_safety?size=${pageSize}&page=${page - 1}&state=U`;
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    this.dataArray = response.data.data.content;
                    
                    // Update pagination info
                    this.pagination1.total = response.data.data.totalElements || 0;
                    this.pagination1.current = page;
                    this.pagination1.pageSize = pageSize;
                    
                    // 정렬
                    this.dataArray = _.orderBy(this.dataArray, ['updated'], ['desc']);

                    // Process array data
                    this.processStateOData();
                    
                    // 바코드 스캔 또는 타겟 설정
                    if (skipBarcodeScan && forceView) {
                        this.handleScannedBarcode();
                    } else if (this.pop) {
                        this.handlePop();
                    }
                }
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        
        fetchStatePData(page = 1, pageSize = 10) {
            // 작성완료(state=P) 데이터 조회
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_safety?size=${pageSize}&page=${page - 1}&state=V`;
            
            if (this.filterDateStartCS || this.filterDateEndCS) {
                if (this.filterDateStartCS) {
                    const startDate = this.formatDateForAPI(this.filterDateStartCS);
                    urlToFetchProductCSList += `&start_date=${startDate}`;
                }
                if (this.filterDateEndCS) {
                    // end_date에는 23:59:59 추가
                    const endDate = this.formatDateForAPI(this.filterDateEndCS, true);
                    urlToFetchProductCSList += `&end_date=${endDate}`;
                }
            }
            
            if (this.filterCS) {
                if (this.filterField === '제목') {
                    urlToFetchProductCSList += `&title=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '대상') {
                    urlToFetchProductCSList += `&line=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '결과') {
                    urlToFetchProductCSList += `&cs_time=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '관리구분') {
                    urlToFetchProductCSList += `&category=${encodeURIComponent(this.filterCS)}`;
                }
            }
            
            console.log('API 요청 URL:', urlToFetchProductCSList);
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    this.dataArray3 = response.data.data.content;
                    
                    // Update pagination info
                    this.pagination2.total = response.data.data.totalElements || 0;
                    this.pagination2.current = page;
                    this.pagination2.pageSize = pageSize;
                    
                    // 정렬
                    this.dataArray3 = _.orderBy(this.dataArray3, ['updated'], ['desc']);

                    // Process array data
                    this.processStatePData();
                }
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
                this.$message.error('데이터 조회 중 오류가 발생했습니다.');
            });
        },
        
        processStateOData() {
            // 기존 데이터 처리 로직
            _.forEach(this.dataArray, function(item) {
                let checkState = '양호';
                _.forEach(item.listProductCSInpection, function(item2) {
                    let tempCheckState = item2.listProductCSInpectionStandard[0].min.split('||')[0];
                    if (tempCheckState === 'X') {
                        checkState = '불량';
                    } else if (tempCheckState === '△' && checkState !== '불량') {
                        checkState = '미흡';
                    }

                    if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                        for (var i = 0; i < 14; i++) {
                            item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                        }
                    } else if (item2.listProductCSInpectionStandard.length === 1) {
                        let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                            max = item2.listProductCSInpectionStandard[0].max.split('||'),
                            name = item2.listProductCSInpectionStandard[0].name.split('||'),
                            result = item2.listProductCSInpectionStandard[0].result.split('||'),
                            ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                            ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                            obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                        for (var j = 0; j < 15; j++) {
                            obj.min = min[j];
                            obj.max = max[j];
                            obj.name = name[j];
                            obj.result = result[j];
                            obj.ngTitle = ngTitle[j];
                            obj.ngContent = ngContent[j];
                            item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                        }
                    }
                });
                item.checkState = checkState;
            });
            
            this.data = [];
            for(let x = 0; x < this.dataArray.length ; x ++) {
                let tags = ['작성중'];

                // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                let updatedObj = new Date((new Date(this.dataArray[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                
                // 날짜 포맷을 시간 없이 날짜만 표시
                this.data.push({
                    key : x,
                    name : this.dataArray[x].name,
                    tags : tags,
                    updated : `${year}-${month}-${date}`,
                    model : this.dataArray[x].clsProduct.productModel,
                    modelDetail : this.dataArray[x].clsProduct.productModelDetail,
                    product : this.dataArray[x].clsProduct.productName,
                    line : this.dataArray[x].line,
                    barcode : this.dataArray[x].barcode,
                    manager : this.dataArray[x].manager,
                    checkState: this.dataArray[x].checkState,
                    category : this.dataArray[x].category,
                    title : this.dataArray[x].title,
                    target : this.dataArray[x].target,
                    productCsSeq: this.dataArray[x].productCsSeq
                });
            }
        },
        
        processStatePData() {
            // 기존 데이터 처리 로직
            _.forEach(this.dataArray3, function(item) {console.log(item)
                let checkState = '양호';
                _.forEach(item.listProductCSInpection, function(item2) {
                    let tempCheckState = item2.listProductCSInpectionStandard[0].min.split('||')[0];
                    if (tempCheckState === 'X') {
                        checkState = '불량';
                    } else if (tempCheckState === '△' && checkState !== '불량') {
                        checkState = '미흡';
                    }

                    if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                        for (var i = 0; i < 14; i++) {
                            item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                        }
                    } else if (item2.listProductCSInpectionStandard.length === 1) {
                        let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                            max = item2.listProductCSInpectionStandard[0].max.split('||'),
                            name = item2.listProductCSInpectionStandard[0].name.split('||'),
                            result = item2.listProductCSInpectionStandard[0].result.split('||'),
                            ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                            ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                            obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                        for (var j = 0; j < 15; j++) {
                            obj.min = min[j];
                            obj.max = max[j];
                            obj.name = name[j];
                            obj.result = result[j];
                            obj.ngTitle = ngTitle[j];
                            obj.ngContent = ngContent[j];
                            item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                        }
                    }
                });
                item.checkState = checkState;
            });
            
            this.data3 = [];
            for(let x = 0; x < this.dataArray3.length ; x ++) {
                let tags = ['작성완료'];

                // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                let updatedObj = new Date((new Date(this.dataArray3[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                
                // 날짜 포맷을 시간 없이 날짜만 표시
                this.data3.push({
                    key : x,
                    name : this.dataArray3[x].name,
                    tags : tags,
                    updated : `${year}-${month}-${date}`,
                    model : this.dataArray3[x].clsProduct.productModel,
                    modelDetail : this.dataArray3[x].clsProduct.productModelDetail,
                    product : this.dataArray3[x].clsProduct.productName,
                    line : this.dataArray3[x].line,
                    barcode : this.dataArray3[x].barcode,
                    manager : this.dataArray3[x].manager,
                    checkState: this.dataArray3[x].checkState,
                    category : this.dataArray3[x].category,
                    title : this.dataArray3[x].title,
                    target : this.dataArray3[x].target,
                    productCsSeq: this.dataArray3[x].productCsSeq
                });
            }
            
            this.data3Backup = JSON.parse(JSON.stringify(this.data3));
        },
        
        handleScannedBarcode() {
            // 바코드 스캔 또는 직접 입력 후 체크시트가 생성된 후의 조회인 경우, 수정, 삭제인 경우
            if (this.dataArray.length > 0) {
                let target = this.dataArray[0];  // 방금 생성하였으므로 맨 처음 체크시트 조회 - 기존에는 맨 끝을 찾았으나 this.dataArray 정렬 순서 변경으로 맨 처음을 찾음
                
                let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_safety_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        let item = response.data.data.content[0];

                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                                    ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    obj.ngTitle = ngTitle[j];
                                    obj.ngContent = ngContent[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        })

                        this.target = item;
                        this.flagForDrawer = true;
                    }
                });
            }
        },
        
        handlePop() {
            // 바코드 스캔한 경우
            if (this.pop) {
                let popMatch = false;
                let matchedCS = null;
                let csItem = sessionStorage.getItem('safety_pop_item');
                if (csItem) {
                    csItem = JSON.parse(csItem);
                    matchedCS = csItem;

                    if (csItem.name == this.pop) {
                        popMatch = true;
                    }
                }

                // 바코드 매칭이 된 경우
                if (popMatch) {
                    if (confirm(csItem.title + ' 작성하시겠습니까?')) {
                        // matchedCS 를 복사해서 valid 값을 C 로 하여 체크시트 생성 후 열기
                        this.handlerToCreateCSForSafety(matchedCS);
                    } else {
                        this.pop = '';
                        sessionStorage.removeItem('safety_pop');
                        sessionStorage.removeItem('safety_pop_item');
                        location.reload();
                    }
                }
            }
        },
        handlerToConfirmProductCS(dataOffset) {
            if (confirm('완료처리하시겠습니까?')) {
                this.data3.push({
                    key: this.dataArray[dataOffset].x,
                    name: this.dataArray[dataOffset].clsProduct.productName,
                    model: this.dataArray[dataOffset].clsProduct.productModel,
                    cs : this.dataArray[dataOffset].name,
                    id: '',
                    created: this.dataArray[dataOffset].created,
                    updated: this.dataArray[dataOffset].updated,
                    tags: ['완료']
                });

                this.data.splice(dataOffset, 1);
            }
        },
        handlerToViewProductCS(dataOffset, state) {
            this.dataOffset = dataOffset;
            let target;
            if (state === 'U') {
                target = this.dataArray[dataOffset];
            } else if (state === 'V') {
                target = this.dataArray3[dataOffset];
            }

            // localStorage 에 저장 여부 확인
            let savedData = localStorage.getItem('cs_item_seq_' + target.productCsSeq);
            if (savedData) {
                this.target = JSON.parse(savedData);
                this.flagForDrawer = true;
            }
            // localStorage 에 없는 경우 API 호출
            else {
                let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_safety_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                    .then((response) => {
                        if(response.status === 200 && response.data.code === 'success') {
                            let item = response.data.data.content[0];

                            _.forEach(item.listProductCSInpection, function(item2) {
                                if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                    for (var i = 0; i < 14; i++) {
                                        item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                    }
                                } else if (item2.listProductCSInpectionStandard.length === 1) {
                                    let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                        max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                        name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                        result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                        ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                                        ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                                        obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                    for (var j = 0; j < 15; j++) {
                                        obj.min = min[j];
                                        obj.max = max[j];
                                        obj.name = name[j];
                                        obj.result = result[j];
                                        obj.ngTitle = ngTitle[j];
                                        obj.ngContent = ngContent[j];
                                        item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                    }
                                }
                            })

                            this.target = item;
                            this.flagForDrawer = true;
                        }
                    });
            }
        },
        handlerToEditSafetyCS(listItem, state) {
            if (!listItem.line) {
                this.$message.error("라인을 선택해주십시오");
                this.flagForDrawer = true;
                return;
            }

            this.flagForDrawer = false;

            let generatedObjectToPersist = {
                productCsSeq: listItem.productCsSeq,
                productSeq: listItem.clsProduct.productSeq,
                productCSName: listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: state,
                pop: listItem.title,
                csTime: listItem.csTime,
                line: listItem.line,
                barcode: listItem.barcode,
                manager: listItem.manager,
            };

            let isNG = false;
            let checkState = '양호';

            _.forEach(listItem.listProductCSInpection, (item) => {
                let tempCheckState = item.listProductCSInpectionStandard[0].min.split('||')[0];
                if (tempCheckState === 'X') {
                    checkState = '불량';
                } else if (tempCheckState === '△' && checkState !== '불량') {
                    checkState = '미흡';
                }

                let min = [],
                    max = [],
                    name = [],
                    result = [],
                    ngTitle = [],
                    ngContent = [];

                _.forEach(item.listProductCSInpectionStandard, function(item2) {
                    min.push(item2.min || '');
                    max.push(item2.max || '');
                    name.push(item2.name || '');
                    result.push(item2.result || '');
                    ngTitle.push(item2.ngTitle || '');
                    ngContent.push(item2.ngContent || '');
                });

                min = min.join('||');
                max = max.join('||');
                name = name.join('||');
                result = result.join('||');
                ngTitle = ngTitle.join('||');
                ngContent = ngContent.join('||');

                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: min,
                        max: max,
                        name: name,
                        result: result,
                        ngTitle: ngTitle,
                        ngContent: ngContent
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: item.inspectionImage2Seq,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);

                if (max.match('FAIL')) {
                    isNG = true;
                }
            });

            if (isNG) {
                generatedObjectToPersist.csTime = 'FAIL';
            } else {
                generatedObjectToPersist.csTime = '';
            }

            generatedObjectToPersist.csTime = checkState;

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/edit';
            this.$http.put(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    // CS 수정 성공 - 안전보건 데이터 저장은 비동기로 처리
                    this.$http.post(this.$store.state.nodeApiUrl + '/product/cs/save_safety_data', {
                        special_note: listItem.special_note || '',
                        productCsSeq: listItem.productCsSeq,
                    }).catch(error => {
                        console.error('안전보건 데이터 저장 오류:', error);
                        // 안전보건 데이터 저장 실패해도 에러 메시지만 표시
                    });

                    // CS 수정 성공했으므로 바로 페이지 새로고침
                    this.$message.success('저장되었습니다');
                    // this.fetchProductCSList(true);

                    // localStorage 에 저장된 데이터 삭제
                    localStorage.removeItem('cs_item_seq_' + listItem.productCsSeq);

                    location.reload();
                } else {
                    this.$message.error('저장되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('저장되지 않았습니다(2).');
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        handlerToDeleteProductCS(dataOffset, state) {
            if (state === 'U') {
                this.target = this.dataArray[dataOffset];
            } else if (state === 'V') {
                this.target = this.dataArray3[dataOffset];
            }

            if (confirm('삭제하시겠습니까?')) {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/delete';
                let listItem = this.target;
                let generatedObjectToPersist = {
                    productCsSeq: listItem.productCsSeq
                };
                this.$http.put(urlForProduct,generatedObjectToPersist)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success('삭제되었습니다');
                            this.fetchProductCSList(true);
                        }  else {
                            this.$message.error('삭제되지 않았습니다(1).');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$message.error('삭제되지 않았습니다(2).');
                    });
            }
        },
        handlerToCreateCSForSafetyPop() {
            if (!this.pop) {
                this.$message.error('제목을 입력해주세요');
                return;
            }
            
            let pop = '' + this.pop;    // SAP 는 숫자만 입력되어 length 체크가 안되므로 문자열로 변환
            if (pop) {
                sessionStorage.setItem('safety_pop', pop);

                let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_safety_cs";

                // POP 는 5자리, SAP 는 6자리
                urlToFetchProductCSList += "?name=" + pop;

                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        if (!response.data.data.content.length) {
                            this.$message.error('입력하신 제목의 점검일지가 등록되어 있지 않습니다.');
                            return;
                        }
                        
                        let item = response.data.data.content[0];
                        sessionStorage.setItem('safety_pop_item', JSON.stringify(item));

                        location.reload();
                    }
                });
            } else {
                this.$message.error('입력하신 제목의 점검일지가 등록되어 있지 않습니다.');
            }
        },
        handlerToCreateCSForSafety(listItem) {
            let productCSName = 'FTCS' + this.$moment(new Date()).format('YYYYMMDD') + '-' + parseInt(Math.random() * 1000000, 10);

            let generatedObjectToPersist = {
                productSeq: listItem.clsProduct.productSeq,
                productCSName: productCSName,
                productCSInspections: [],
                productCSTimes: [],
                state: 'U',
                pop: this.pop,
                csTime: ''
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].min || '',
                        max: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].max || '',
                        name: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].name || '',
                        result: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].result || ''
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: 0,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });

            this.$http.post(this.$store.state.nodeApiUrl + '/product/cs/save_safety_data', {
                category: listItem.category,
                title: listItem.title,
                target: listItem.target,
                name: productCSName,
                pendingLink: true,
            })
            .then(() => {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/add';
                return this.$http.post(urlForProduct, generatedObjectToPersist);
            })
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('생성되었습니다');
                    this.fetchProductCSList(true, true);
                    this.pop = '';
                    sessionStorage.removeItem('safety_pop');
                    sessionStorage.removeItem('safety_pop_item');
                } else {
                    return Promise.reject('생성되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error(typeof error === 'string' ? error : '생성되지 않았습니다(2).');
            });
        },
        filterCSList() {
            // 검색 파라미터 변경 시 첫 페이지로 이동
            this.pagination2.current = 1;
            
            // 필터링 상태 설정
            this.isFiltered = !!(this.filterCS || this.filterDateStartCS || this.filterDateEndCS);
            
            // 작성완료(state=P) 데이터를 새로 조회
            this.fetchStatePData(1, this.pagination2.pageSize);
            
            // 검색 완료 메시지 표시
            if (this.filterCS || this.filterDateStartCS || this.filterDateEndCS) {
                this.$message.info('검색이 완료되었습니다');
            }
            
            // 로그 추가 (디버깅용)
            console.log('필터링 적용:', {
                필드: this.filterField,
                검색어: this.filterCS,
                시작일: this.filterDateStartCS,
                종료일: this.filterDateEndCS
            });
        },
        
        handleTable1Change(pagination) {
            // 작성중(state=O) 테이블의 페이지 변경 시
            this.fetchStateOData(false, false, pagination.current, pagination.pageSize);
        },
        
        handleTable2Change(pagination) {
            // 작성완료(state=P) 테이블의 페이지 변경 시
            this.fetchStatePData(pagination.current, pagination.pageSize);
        },
        fetchTitleOptions() {
            this.titleOptionsLoading = true;
            let url = `${this.$store.state.nodeApiUrl}/product/cs/list_safety?size=1000&state=T`;
            
            this.$http.get(url)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        this.allTitleOptions = response.data.data.content || [];
                        this.filterTitleOptions();
                    } else {
                        this.$message.error('제목 목록을 불러오는데 실패했습니다.');
                    }
                    this.titleOptionsLoading = false;
                })
                .catch(error => {
                    console.error('Failed to fetch title options:', error);
                    this.$message.error('제목 목록을 불러오는데 실패했습니다.');
                    this.titleOptionsLoading = false;
                });
        },
        
        filterTitleOptions() {
            if (this.sheetCategory) {
                this.titleOptions = this.allTitleOptions.filter(option => 
                    option.category === this.sheetCategory
                );
            } else {
                this.titleOptions = [...this.allTitleOptions];
            }
            
            // 카테고리 변경 시 이전에 선택된 pop 값이 현재 카테고리에 없으면 초기화
            if (this.pop) {
                const popExists = this.titleOptions.some(option => option.name === this.pop);
                if (!popExists) {
                    this.pop = null;
                }
            }
            
            // 카테고리 저장
            sessionStorage.setItem('safety_category', this.sheetCategory);
        },
        
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        formatDateForAPI(dateString, isEndDate = false) {
            // 날짜 형식이 이미 올바른지 확인
            if (!dateString) return '';
            
            try {
                // YYYY-MM-DD 형식 확인
                if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
                    return isEndDate ? `${dateString} 23:59:59` : dateString;
                }
                
                // 날짜 포맷팅이 필요한 경우
                const date = new Date(dateString);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                
                const formattedDate = `${year}-${month}-${day}`;
                return isEndDate ? `${formattedDate} 23:59:59` : formattedDate;
            } catch (error) {
                console.error('날짜 형식 변환 오류:', error);
                return dateString; // 오류 시 원래 문자열 반환
            }
        },
        resetFilters() {
            // 필터 초기화
            this.filterCS = '';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.filterField = '관리구분';
            this.isFiltered = false;
            
            // 첫 페이지로 이동하고 데이터 다시 로드
            this.fetchStatePData(1, this.pagination2.pageSize);
            this.$message.success('필터가 초기화되었습니다');
        },
    }
}
</script>
<style scoped>
.native-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    height: 32px;
    line-height: 32px;
    min-width: 0;
    outline: none;
    padding: 0 11px;
    position: relative;
    transition: all 0.3s;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%23595959%22%20d%3D%22M6%208L2%204h8z%22%2F%3E%3C%2Fsvg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    padding-right: 24px;
}

.native-select:hover {
    border-color: #40a9ff;
}

.native-select:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    outline: 0;
}

.filter-input-container {
    display: inline-block;
    vertical-align: middle;
}

.custom-input-group {
    display: flex;
    align-items: stretch;
}

.custom-input-group .ant-input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

/* 필터 셀렉트 박스 스타일 수정 */
.filter-select {
    min-width: 100px;
    margin: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    background-color: #fafafa;
}

/* 검색 결과가 없을 때도 유사한 스타일 유지 */
select.native-select option {
    padding: 8px 12px;
}

/* iOS 장치에서 select 스타일 일관성 유지 */
@supports (-webkit-touch-callout: none) {
    .native-select {
        font-size: 16px; /* iOS에서 16px 이상이면 자동 확대 방지 */
    }
}
</style>